import React, { Fragment, useEffect, useState, useContext } from 'react'
import dayjs from 'dayjs';
import lodash, { size } from 'lodash';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { CSelectV1 } from "components/atomic/Input";

// Assets
import { ReactComponent as Dot } from 'assets/dot.svg';
import { ReactComponent as CheckIcon } from 'assets/green-circle-check.svg';
import { ReactComponent as WarningIcon } from 'assets/red-warning.svg';
import { ReactComponent as InfoIcon } from 'assets/info-bg-black.svg';
import { ReactComponent as NextIcon } from 'assets/next.svg';
import { ReactComponent as PrevIcon } from 'assets/previous.svg';

// Components
import ModalLoader from 'components/organism/ModalLogout';

// Context
import { GlobalContext } from "contexts";
import { useDebounce } from 'hooks/useDebounce';

// API
import { getRumah123 } from "actions"
import { getMarketingAgent } from "actions";

const FilterButton = ({ className = "", children, isActive, ...props }) => <button {...props} className={`py-[10px] px-4 border-[1px] border-solid border-black-3 ${className} ${isActive ? "bg-black-0 text-white" : "bg-white"}`}>{children}</button>

const TableSize = {
  no: "7.71%",
  date: "20.13%",
  name: "20.13%",
  phoneNumber: "17.7%",
  listingId: "20.13%",
  adsUrl: "14.2%",
}

const HeaderText = "text-xs text-gray-0";

const CopyButton = ({ payload }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(payload))

    toast.success("Berhasil menyalin", {
      position: toast.POSITION.TOP_CENTER
    });
  }

  return <button className='cursor-pointer text-blue-0 underline text-sm' onClick={handleCopy}>Copy JSON</button>
}

const TableRow = ({ no, date, hour, name, phoneNumber, listingId, status, adsUrl, message, payload }) => (
  <Fragment>
    <div className='w-full flex'>
      <div style={{ width: TableSize.no }} className={`pt-6 pb-4 mr-2 text-sm`}>{no}</div>
      <div style={{ width: TableSize.date }} className={`pt-6 pb-4 mr-2 text-sm`}>
        <div className='flex items-center'>
          <span className='text-gray-2 text-sm'>{date}</span>
          <Dot className="w-2 h-2 px-4" />
          <span className='text-gray-2 text-sm'>{hour}</span>
        </div>
      </div>
      <div style={{ width: TableSize.name }} className={`pt-6 pb-4 mr-2 text-sm`}>{name}</div>
      <div style={{ width: TableSize.phoneNumber }} className={`pt-6 pb-4 mr-2 text-sm font-sfpro-medium`}>{phoneNumber}</div>
      <div style={{ width: TableSize.listingId }} className={`pt-6 pb-4 mr-2 text-sm font-sfpro-medium`}>
        <div className='flex items-center'>
          <span className='text-gray-2 text-sm'>#{listingId}</span>
          <Dot className="w-2 h-2 px-4" />
          <span className={`${status === "Error" ? "text-red-0" : status === "Completed" ? "text-green-1" : "text-gray-2"} text-sm font-sfpro-medium`}>{status}</span>
        </div>
      </div>
      <div style={{ width: TableSize.adsUrl }} className={`pt-6 pb-4`}>
        <div className='flex items-center justify-between'>
          {(!!adsUrl && status === "Completed") ? <a href={adsUrl} target="_blank" className={`underline text-sm`}>Lihat Iklan</a> : <span className={`underline text-sm text-black-3`}>Lihat Iklan</span>}
          
          <CopyButton payload={payload} />
        </div>
      </div>
    </div>
    <div className='w-full pt-6 pb-4 bg-white-4 border-t-[1px] border-solid border-t-white-3'>
      <div className='flex'>
        {status === "Error" ? <WarningIcon className='w-4 h-4 mr-2' /> : status === "Completed" ? <CheckIcon className='w-4 h-4 mr-2' /> : <InfoIcon className='w-4 h-4 mr-2' />}
        <div>
          <p className='text-xs text-gray-0 mb-[2px]'>Respon Rumah123</p>
          <p className='text-xs mb-[12px]'>{message}</p>
        </div>
      </div>
      <div className='h-[4px] w-full bg-white-0' />
    </div>
  </Fragment>
)

const ProgressTrackerRumah123 = () => {
  const { profile } = useContext(GlobalContext);

  const [totalPage, setTotalPage] = useState(0)
  const [dataListing, setDataListing] = useState([])
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState("")

  const [agents, setAgents] = useState({
    data: [],
    fetching: true,
    error: ""
  })

  const [params, setParams] = useState({
    page: 1,
    size: 10,
    agent: null,
    search: ""
  })

  const [inputPage, setInputPage] = useState(params.page)

  const { debounceFn } = useDebounce({
    onChange: (newParams) => setParams(newParams)
  })


  const handleNextPage = () => {
    if (params.page === totalPage) return;
    setParams({ ...params, page: params.page + 1 })
  }

  const handlePrevPage = () => {
    if (params.page === 1) return;

    setParams({ ...params, page: params.page - 1 })
  }

  const handleOnChangeShortcut = (e) => {

    const { value } = e.target ?? 1;
    setInputPage(+value)
  }

  const onSelectHandler = async (e, options, valueName) => {
    const { value } = e.target
    const agent = options.find((option) => option[valueName] === +value)

    setParams({ ...params, agent, page: 1 })
  }

  const handleGetRumah123 = async () => {
    try {
      setLoading(true)

      let query = `?page=${params.page}&size=${params.size}`

      if (!!params.search) {
        query += `&property_id=${params.search}`
      }

      if (!!params.agent) {
        query += `&full_name=${params.agent?.full_name}`
      }

      const response = await getRumah123(query)
      const totalItem = response?.headers?.["x-total"]
      const totalPage = lodash.ceil(totalItem / 10) || 0

      setTotalPage(totalPage)
      setDataListing(response?.data?.data ?? [])
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const getAgents = async (page = 1) => {
    try {
      setAgents(val => ({ ...val, fetching: true, error: "" }))

      const list = await getMarketingAgent(`?page=${page}&_limit=1000`)

      const newData = list?.data ?? []

      setAgents(val => ({ ...val, data: newData }))
    } catch (error) {
      setAgents(val => ({ ...val, error }))
    } finally {
      setAgents(val => ({ ...val, fetching: false }))
    }
  }

  const handleSearch = (e) => {
    setSearch(e?.target?.value)
    debounceFn({ ...params, search: e?.target?.value, page: 1 })
  }

  useEffect(() => {
    handleGetRumah123()
  }, [params])

  useEffect(() => {
    getAgents()
  }, [])

  return (
    <>
      <div className='relative w-[calc(100vw-193px)] ml-[193px] flex flex-col items-center bg-white-2'>
        {/** Header */}
        <div className='bg-white w-full p-8 flex items-end justify-between border-b-[0.5px] border-solid border-white-0 box-shadow-0'>
          <div>
            <p className='text-3xl font-sfpro-medium mb-2'>Rumah123 Listing Progress Tracker</p>
            <p className='text-gray-2 text-base'>Selamat datang kembali, {profile?.full_name ?? ""}!</p>
          </div>

          {/* <div className='rounded-md flex items-center h-[40px]'>
            <FilterButton isActive={true} className='rounded-l-md'>Rumah123</FilterButton>
            <FilterButton isActive={false}>Site 2</FilterButton>
            <FilterButton isActive={false}>Site 3</FilterButton>
            <FilterButton isActive={false} className='rounded-r-md'>Site 4</FilterButton>
          </div> */}
        </div>

        {/** TABEL */}
        <div className='w-[calc(100%-64px)] mt-[55px] mb-[123px] bg-white py-4 px-8 rounded-md border-[0.5px] border-solid border-white-0'>
          <div className='flex items-center w-full py-4 px-6 bg-white mb-4 border-b-[0.5px] border-solid border-white-0'>
            <p className='text-base text-black-1 mr-4'>Cari berdasarkan</p>
            <div className='flex items-center'>
              <div className='w-[500px] px-[16px] py-[10px] rounded-md border-[1px] border-white-0 mr-4'>
                <input
                  placeholder='Id listing (e.g. 12345), nama marketing'
                  className='w-full text-sm placeholder:text-gray-0'
                  disabled={loading}
                  value={search}
                  onChange={handleSearch}
                />
              </div>
              <CSelectV1
                className='marketing-agent-name mr-[8px]'
                placeholder="Marketing"
                options={agents.data}
                displayName="full_name"
                valueName="id"
                name="ma_id"
                value={params.agent || {}}
                onSelect={onSelectHandler}
                disabled={loading}
              />
            </div>
          </div>
          <div className='w-full'>
            <div className='py-4 flex w-full'>
              <div style={{ width: TableSize.no }} className={`mr-2 ${HeaderText}`}>No</div>
              <div style={{ width: TableSize.date }} className={`mr-2 ${HeaderText}`}>Tanggal & Jam</div>
              <div style={{ width: TableSize.name }} className={`mr-2 ${HeaderText}`}>Nama User</div>
              <div style={{ width: TableSize.phoneNumber }} className={`mr-2 ${HeaderText}`}>Nomor HP</div>
              <div style={{ width: TableSize.listingId }} className={`mr-2 ${HeaderText}`}>ID listing</div>
              <div style={{ width: TableSize.adsUrl }} className={`mr-2 ${HeaderText}`}>URL Iklan</div>
            </div>

            {!!dataListing?.length && dataListing.map((d, i) => {
              const listing = d?.response?.listing ?? d?.response?.data?.[0]?.listing;
              const errorMsg = listing?.errors?.[0];
              const statusNot200 = listing?.status !== 200;
              const message = listing?.message;
              const mappedData = {
                no: i + 1,
                date: !!d?.updated_at ? dayjs(d.updated_at).format('DD MMM, YYYY') : "",
                hour: !!d?.updated_at ? dayjs(d.updated_at).format('HH:mmA') : "",
                name: d?.user?.full_name ?? "",
                phoneNumber: d?.user?.phone ?? "",
                listingId: d?.property?.id,
                status: d?.status ?? "",
                adsUrl: d?.url_listing ?? "",
                message: (!!errorMsg && statusNot200) ? `${d?.status}, ${errorMsg}` : message,
                payload: d?.payload ?? {}
              }
              return <TableRow key={`detail-listing-${i + 1}`} {...mappedData} />
            })}
          </div>
        </div>

        {/** FOOTER */}
        <div className='fixed justify-between left-[193px] bottom-0 w-[calc(100vw-193px)] bg-white py-[40px] px-[32px] flex items-center box-shadow-1 border-[0.5px] border-solid border-white-0'>
          <div className='flex items-center'>
            <p className='text-sm text-gray-2 mr-[32px]'>Pergi ke halaman</p>
            <div className='flex items-center border-gray-2 border-[1px] border-solid rounded-[8px] px-4 py-[10px]'>
              <input min={1} onChange={handleOnChangeShortcut} value={!!inputPage ? inputPage : ""} max={totalPage} className='w-[32px] h-[20px] mr-2' placeholder='0' type='number' />
              <NextIcon onClick={() => setParams({ ...params, page: +inputPage })} className='w-[14px] h-[14px] object-contain cursor-pointer' />
            </div>
          </div>

          <div className='flex items-center'>
            <button onClick={handlePrevPage} className='flex items-center text-sm text-gray-0 border-[1px] border-solid rounded-md border-black-3 px-4 py-[10px]'><PrevIcon className='w-[14px] h-[14px] object-contain mr-2' /> Sebelumnya</button>
            <p className='px-[32px] text-sm'>{params.page} <span className='text-gray-2'>dari</span> {totalPage} <span className='text-gray-2'>halaman</span></p>
            <button onClick={handleNextPage} className='flex items-center text-sm text-gray-0 border-[1px] border-solid rounded-md border-black-3 px-4 py-[10px]'>Selanjutnya <NextIcon className='w-[14px] h-[14px] object-contain ml-2' /></button>
          </div>
        </div>

      </div>
      {loading && <ModalLoader open={true} />}
    </>
  )
}

export default ProgressTrackerRumah123